import { useGet, usePost } from "@albertine/api-client";
import { useQueryClient } from "@tanstack/react-query";
import Button from "../Common/Buttons";
import "./Settings.css";

const CONTRIBUTION_TOTALS_QUERY_KEY = ["contributionTotals", {}] as const;

export function AlbertineContributions() {
    const queryClient = useQueryClient();
    const { data: contributions } = useGet("contributionTotals", {}, { retry: false });
    const { mutate: refreshContributionTotals, isPending: refreshPending } = usePost(
        "refreshContributionTotals",
        {
            onSuccess: (totals) => {
                queryClient.setQueryData(CONTRIBUTION_TOTALS_QUERY_KEY, totals);
                void queryClient.invalidateQueries({
                    queryKey: ["contributionTotals"],
                });
            },
        },
    );

    return (
        <div className="panel">
            <h2>Albertine Philanthropy Contributions</h2>
            {contributions ? (
                <ul>
                    <li>
                        {Number(contributions.trees).toLocaleString()} trees for the
                        climate
                    </li>
                    <li>
                        {Number(contributions.kilograms).toLocaleString()} kg of giant
                        kelp for the oceans
                    </li>
                    <li>
                        {Number(contributions.squareMeters).toLocaleString()} m² of
                        habitat for biodiversity
                    </li>
                </ul>
            ) : (
                "Press recalculate to get initial values."
            )}
            <div>
                <Button.P50
                    onClick={() => refreshContributionTotals({})}
                    disabled={refreshPending}
                >
                    Recalculate
                </Button.P50>
            </div>
        </div>
    );
}
